import React, { useState } from 'react';
import MInfoCard from '@/components/ui/atoms/MInfoCard';
import { IconInfoCircle, IconCheck, IconCircle, IconDotsVertical, IconPrescription, IconTrash, IconPencil } from '@tabler/icons-react';
import MAvatar from '@/components/ui/atoms/MAvatar';
import { IconDoctor, IconTherapySession } from '@/components/icons';

const MInfoTest: React.FC = () => {
  const [checked, setChecked] = useState(false);
  const [selected, setSelected] = useState(false);

  return (
    <div style={{ padding: 32, background: '#f8f8f8', minHeight: '100vh', display: 'flex', flexDirection: 'column', gap: 24 }}>
      <h2>MInfoCard Atom Test</h2>
      <MInfoCard
        primaryLabel="CGHS"
        secondaryLabel="Primary holder: PV"
        tertiaryLabel="Valid until: 22 Feb 2030"
        ctaLabel='View Policy'
        showCTA
        variant='radio'
        onAction={() => alert('CTA Clicked')}
        onSelect={setSelected}
        selected={selected}
      />
      <MInfoCard
        primaryLabel="CGHS"
        variant="checkbox"
        checked={checked}
        onCheck={setChecked}
      />
      <MInfoCard
        primaryLabel="With Radio"
        secondaryLabel="Radio Option"
        variant="radio"
        selected={selected}
        onSelect={(val) => setSelected(val)}
      />
      <MInfoCard
        primaryLabel="With Options Menu"
        secondaryLabel="Options variant"
        variant="actionsMenu"
        actions={[
          {
            id: 'edit',
            label: 'Mark as Done',
            icon: <IconPencil  />,
            onClick: () => alert('Edit clicked')
          },
        ]}
      />
      <MInfoCard
        primaryLabel="prescription-rxdx.pdf"
        secondaryLabel="From WhatsApp"
        tertiaryLabel='25 Aug 2025 at 9:41 AM'
        variant="custom"
        rightActionComponent={
          <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
            <span className="body-xs-semibold">Assigned to</span>
            <div style={{marginTop:12}}>
              <MAvatar type="no-dp" size="sm" text='P V'/>
            </div>
          </div>
        }
      />
      <MInfoCard
        primaryLabel="prescription-rxdx.pdf"
        secondaryLabel="From WhatsApp"
        tertiaryLabel='25 Aug 2025 at 9:41 AM'
        variant="labels"
        labelText="Processing"
        labelColor="orange"
        onLabelClick={() => alert('Red label clicked')}
      />
      <MInfoCard
        primaryLabel="Paracetamol"
        tertiaryLabel="Reminder set for"
        emphasizedLabel="24 Jul at 9:00AM"
        showEmphasizedTertiary
        leftIcon={<IconDoctor />}
        variant="actionsMenu"
        actions={[
          {
            id: 'edit',
            label: 'Edit',
            icon: <IconInfoCircle />,
            onClick: () => alert('Edit clicked')
          },
          {
            id: 'delete',
            label: 'Delete',
            icon: <IconTrash  />,
            onClick: () => alert('Delete clicked'),
          }
        ]}
      />
    </div>
  );
};

export default MInfoTest;
